import { Card, CardProps } from "@mui/material";
import React, { ReactNode } from "react";
import { CHART_COLORS } from "./app/provider/patient/chart";

type OutlineCardV2Props = {
  children: ReactNode;
  background?: string;
} & CardProps;

const OutlineCardV2: React.FC<OutlineCardV2Props> = ({
  children,
  background,
  ...others
}) => (
  <Card
    sx={{
      height: (others?.sx as any)?.height ?? "auto",
      padding: (others?.sx as any)?.padding ?? 0,
      borderRadius: "4px",
      border: `1px solid ${CHART_COLORS.border}`,
      boxShadow: "none",
      overflow: "hidden",
      ...others?.sx,
    }}
    variant="outlined"
    {...(others?.sx ? undefined : others)}
  >
    {children}
  </Card>
);

export default OutlineCardV2;
